import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Button, Container } from "semantic-ui-react";

import { ViewClinicalHistoryButton } from "@teamprevent/common/referralReport/components/ViewClinicalHistoryButton";
import { openSection } from "@teamprevent/common/questionnaires/actions";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { MHP_TREATMENT_CONSULTATION } from "../models";
import { DidNotAttendButton } from "../../clinicalNotes/components/DidNotAttendButton";

import { PreviewMHPTreatmentReportButton } from "./PreviewMHPTreatmentReportButton";

interface Props {
    customerId: string;
    ohCaseId: string;
    employeeRecordId: string;
    task: TaskModel;
    onDNAAction: (showConsultationSections: boolean) => void;
}

export const CompleteConsultationButtons: React.FunctionComponent<Props> = (props: Props) => {

    const dispatch = useDispatch();

    const startNotes = React.useCallback(
        () => dispatch(openSection({ sectionId: "CompletedOnBehalfOf", questionnaireKey: MHP_TREATMENT_CONSULTATION })),
        [dispatch]
    );

    return (
        <>
            <p>
                I am an Occupational Health Advisor with Optima Health working on behalf of your employer. I am calling as your manager has referred
                you to Occupational Health in order to determine how best to support you. My role is to assess your current health situation and to
                provide advice to you and your manager. Is it convenient to talk?
            </p>
            <Container textAlign="right" className="start-button">
                <ViewClinicalHistoryButton
                    customerId={props.customerId}
                    employeeRecordId={props.employeeRecordId}
                />
                <PreviewMHPTreatmentReportButton
                    customerId={props.customerId}
                    employeeRecordId={props.employeeRecordId}
                    ohCaseId={props.ohCaseId}
                    taskId={props.task.id}
                />
                <DidNotAttendButton
                    customerId={props.customerId}
                    ohCaseId={props.ohCaseId}
                    task={props.task}
                />
                <Button type="button" onClick={startNotes} content="Start Notes" />
            </Container>
        </>
    );
};
